import * as React from "react";
import { connect } from "react-redux";
import MaskedInput from 'react-text-mask'
import {
    Button,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Row,
    Col
} from "reactstrap";
import Header from "./Header";
import { FormStep, Step } from "../../store/application/applicationState";
import { CPRAttribute } from "../../models/cprattribute";
import {
    setCprAndPaymentMethod,
    sendApplication,
    gotoStep,    setAlmBrandConsent,
    setAseConsent
} from "../../store/application/applicationActions";
import { RootState } from "../../store";
import { PaymentMethod } from "../../lib-api";
import ApplicationFooter from "../applicationFooter";
import ApplicationContent from "../applicationContent";
import { trackEvent } from "../../util/gtm";
import { HasOldLoan } from "../../lib-api/models/HasOldLoan";

import CurrencyInput from "./CurrencyInput";
import { OldLoanAmountAttribute } from "../../models/OldLoanAmountAttribute";
import { RegNrAttribute } from "../../models/regnrattribute";
import { AccountNrAttribute } from "../../models/accountnrattribute";

import { ApplicationApi, AseApi, AlmBrandApi } from "../../lib-api";
import { apiConfiguration } from "../../api-configuration";

interface StepPaymentState {
    dirty: boolean;
    cpr: string;
    paymentMethod: PaymentMethod;
    hasOldLoan: HasOldLoan;
    oldLoanAmount: string;
    regNr: string;
    accountNr: string;
    aseConsent: boolean;
    almBrandConsent: boolean;
    name: string;
    email: string;
    mobile: string;
    address: string;
    postalcode: string;
    city: string;
    id: string;

}

type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

class StepPayment extends React.Component<Props, StepPaymentState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            dirty: false,
            cpr: props.application.data.cpr,
            paymentMethod: props.application.data.paymentMethod,
            hasOldLoan: props.application.data.hasOldLoan,
            oldLoanAmount: "",
            regNr: "",
            accountNr: "",
            aseConsent: false,
            almBrandConsent: false,
            name: props.application.data.name,
            email: props.application.data.email,
            mobile: props.application.data.mobile,
            address: props.application.data.address,
            postalcode: props.application.data.postalcode,
            city: props.application.data.city,
            id: props.application.application.id

        };

        this.submit = this.submit.bind(this);
    }

    paymentClick(paymentService: boolean, paymentForms: boolean): void {
        //LoanForm.instance.setStateVar("paymentservice", paymentService);
        //LoanForm.instance.setStateVar("paymentforms", paymentForms);
    }

    submit(): void {
        this.setState({ dirty: true });

        let cprValid = (!CPRAttribute.hasError(this.state.cpr) && !CPRAttribute.isCoAppDuplicate(this.state.cpr, this.props.application.data.cocpr));
        let oldAmountValid = !OldLoanAmountAttribute.hasError(this.state.oldLoanAmount);
        let regNrValid = !RegNrAttribute.hasError(this.state.regNr);
        let accountNrValid = !AccountNrAttribute.hasError(this.state.accountNr);


        if (cprValid && this.state.paymentMethod && this.state.hasOldLoan) {
            if (this.state.hasOldLoan == HasOldLoan.Ja && oldAmountValid) {
                if (this.state.paymentMethod == PaymentMethod.PBS && regNrValid && accountNrValid) {
                    this.props.setCprAndPaymentMethod(
                        this.state.cpr,
                        this.state.paymentMethod,
                        this.state.hasOldLoan,
                        this.state.oldLoanAmount,
                        this.state.accountNr,
                        this.state.regNr
                    );
                }
                else if (this.state.paymentMethod == PaymentMethod.GIRO) {
                    this.props.setCprAndPaymentMethod(
                        this.state.cpr,
                        this.state.paymentMethod,
                        this.state.hasOldLoan,
                        this.state.oldLoanAmount,
                        this.state.accountNr,
                        this.state.regNr
                    );
                }

            } else if (this.state.hasOldLoan == HasOldLoan.Nej) {
                if (this.state.paymentMethod == PaymentMethod.PBS && regNrValid && accountNrValid) {
                    this.props.setCprAndPaymentMethod(
                        this.state.cpr,
                        this.state.paymentMethod,
                        this.state.hasOldLoan,
                        "",
                        this.state.accountNr,
                        this.state.regNr
                    );
                }
                else if (this.state.paymentMethod == PaymentMethod.GIRO) {
                    this.props.setCprAndPaymentMethod(
                        this.state.cpr,
                        this.state.paymentMethod,
                        this.state.hasOldLoan,
                        "",
                        this.state.accountNr,
                        this.state.regNr
                    );
                }
                this.props.setAseConsent(this.state.aseConsent);
        //this.props.setAlmBrandConsent(this.state.almBrandConsent);


           
            }
            trackEvent(
                "Optaget andre lån",
                (this.state.hasOldLoan == HasOldLoan.Ja.toString()) ? "Ja " + this.state.oldLoanAmount + " kr." : "Nej",
                "Optaget andre lån",
                (this.state.hasOldLoan == HasOldLoan.Ja.toString()) ? "Ja" + this.state.oldLoanAmount + " kr." : "Nej"
            ),
                trackEvent(
                    "BetalingsMetode",
                    (this.state.paymentMethod == PaymentMethod.PBS) ? "BetalingsService" : "Indbetalingskort",
                    "BetalingsMetode",
                    (this.state.paymentMethod == PaymentMethod.PBS) ? "BetalingsService" : "Indbetalingskort"
                );
            if (this.state.aseConsent == true) {
                const aseApi = new AseApi(apiConfiguration);
                const fullName = this.state.name.split(" ");
                try {
                    const Ase = aseApi.apiAseSendInfoPost({
                        firstName: fullName[0],
                        lastName: fullName[fullName.length - 1],
                        email: this.state.email,
                        phone: this.state.mobile.toString(),
                        address: this.state.address,
                        postalcode: this.state.postalcode,
                        city: this.state.city,
                        id: JSON.parse(this.state.id),
                    })
                } catch (e) {
                }
            }
            var goto = this.props.sendApplication()
            window.location.href = "/w-7000151";
        }
    }

    aseChange = e => {
        const { accepted } = e.target;
        this.setState({
            aseConsent: !this.state.aseConsent
        });
    };

    AlmBrandChange = e => {
        const { accepted } = e.target;
        this.setState({
            almBrandConsent: !this.state.almBrandConsent
        });
    };

    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "11");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        var year = new Date().getFullYear();
        return (
            <div className="signup-container">
                <Header formStep={FormStep.Payment} step={Step.Payment} />
                <ApplicationContent>
                    <FormGroup>
                        <div>
                            <p>Har du optaget andre lån siden 1. Januar {year}?</p>


                            <CustomInput
                                invalid={this.state.dirty && !this.state.hasOldLoan}
                                type="radio"
                                id="ja"
                                name="hasOldLoan"
                                label="Ja"
                                checked={this.state.hasOldLoan == HasOldLoan.Ja}
                                onChange={e =>
                                    e.target.checked &&
                                    this.setState({ hasOldLoan: HasOldLoan.Ja })
                                }
                            />
                            <CustomInput
                                invalid={this.state.dirty && !this.state.hasOldLoan}
                                type="radio"
                                id="nej"
                                name="hasOldLoan"
                                label="Nej"
                                checked={this.state.hasOldLoan == HasOldLoan.Nej}
                                onChange={e =>
                                    e.target.checked &&
                                    this.setState({ hasOldLoan: HasOldLoan.Nej })
                                }
                            />

                            {this.state.hasOldLoan == HasOldLoan.Ja &&
                                <FormGroup>
                                    <Label for="oldLoanAmount" className="text-uppercase font-weight-bold">
                                        Skriv beløb
                        </Label>
                                    <CurrencyInput
                                        maskOptions
                                        className={
                                            this.state.dirty && OldLoanAmountAttribute.hasError(this.state.oldLoanAmount)
                                                ? "is-invalid cpr form-control"
                                                : "cpr form-control"
                                        }
                                        type="text"
                                        id="oldLoanAmount"
                                        name="oldLoanAmount"
                                        placeholder="Indtast beløb"
                                        value={this.state.oldLoanAmount}

                                        onChange={event => this.setState({ oldLoanAmount: event.target.value })}
                                    />
                                    {this.state.dirty && OldLoanAmountAttribute.hasError(this.state.oldLoanAmount) && (
                                        <div className="invalid-feedback">
                                            {OldLoanAmountAttribute.getErrorMessage()}
                                        </div>
                                    )}
                                </FormGroup>
                            }

                            <br />
                        </div>
                        <div>

                            <p>Hvordan ønsker du at håndtere tilbagebetaling af lånet?</p>
                            <CustomInput
                                invalid={this.state.dirty && !this.state.paymentMethod}
                                type="radio"
                                id="betalingsservice"
                                name="payment"
                                label="Betalingsservice"
                                checked={this.state.paymentMethod == PaymentMethod.PBS}
                                onChange={e =>
                                    e.target.checked &&
                                    this.setState({ paymentMethod: PaymentMethod.PBS })
                                }
                            />
                            {this.state.paymentMethod == PaymentMethod.PBS &&
                                <FormGroup className="row paymentServiceForm">
                                    <div className=" col-5 col-sm-3 col-md-2 py-2 px-2">
                                        <Label for="mobile" className="text-uppercase font-weight-bold">
                                            Dit Reg.Nr
                                </Label>
                                        <Input
                                            className={
                                                this.state.dirty && RegNrAttribute.hasError(this.state.regNr)
                                                    ? "is-invalid"
                                                    : ""
                                            }
                                            type="text"
                                            id="regNr"
                                            name="regNr"
                                            inputMode="numeric"
                                            placeholder="Indtast Reg.nr."
                                            value={this.state.regNr}
                                            maxLength={4}
                                            onChange={event => this.setState({ regNr: event.target.value })}
                                        />

                                        {this.state.dirty &&
                                            RegNrAttribute.hasError(this.state.regNr) && (
                                                <div className="invalid-feedback">
                                                    {RegNrAttribute.getErrorMessage()}
                                                </div>
                                            )}
                                    </div>
                                    <div className=" col-6 col-sm-4 col-md-3 py-2 px-2">
                                        <Label for="mobile" className="text-uppercase font-weight-bold">
                                            Dit konto.nr.
                                </Label>
                                        <Input
                                            className={
                                                this.state.dirty && AccountNrAttribute.hasError(this.state.accountNr)
                                                    ? "is-invalid"
                                                    : ""
                                            }
                                            type="text"
                                            id="kontonr"
                                            name="kontonr"
                                            inputMode="numeric"
                                            placeholder="Indtast konto.nr."
                                            value={this.state.accountNr}
                                            maxLength={10}
                                            onChange={event => this.setState({ accountNr: event.target.value })}
                                        />
                                        {this.state.dirty &&
                                            AccountNrAttribute.hasError(this.state.accountNr) && (
                                                <div className="invalid-feedback">
                                                    {AccountNrAttribute.getErrorMessage()}
                                                </div>
                                            )}
                                    </div>
                                </FormGroup>

                            }


                            <CustomInput
                                invalid={this.state.dirty && !this.state.paymentMethod}
                                type="radio"
                                id="indbetalingskort"
                                name="payment"
                                label="Indbetalingskort"
                                checked={this.state.paymentMethod == PaymentMethod.GIRO}
                                onChange={e =>
                                    e.target.checked &&
                                    this.setState({ paymentMethod: PaymentMethod.GIRO })
                                }
                            />
                        </div>
                    </FormGroup>

                    <p>Angiv dit CPR nummer for at starte validering via NemID.</p>

                    <FormGroup>
                        <Label for="cpr" className="text-uppercase font-weight-bold">
                            Dit CPR.NR
                        </Label>

                        <MaskedInput

                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            className={
                                this.state.dirty && (CPRAttribute.hasError(this.state.cpr) || CPRAttribute.isCoAppDuplicate(this.state.cpr, this.props.application.data.cocpr))
                                    ? "is-invalid cpr form-control"
                                    : "cpr form-control"
                            }
                            type="text"
                            id="cpr"
                            name="cpr"
                            inputMode="numeric"
                            placeholder="Indtast CPR nr."
                            value={this.state.cpr}
                            onChange={event => this.setState({ cpr: event.target.value })}
                        />

                        {this.state.dirty && CPRAttribute.hasError(this.state.cpr) && (
                            <div className="invalid-feedback">
                                {CPRAttribute.getErrorMessage()}
                            </div>
                        )}
                        {this.state.dirty && CPRAttribute.isCoAppDuplicate(this.state.cpr, this.props.application.data.cocpr) && (
                            <div className="invalid-feedback">
                                {CPRAttribute.getDuplicateErrorMessage()}
                            </div>
                        )}
                    </FormGroup>
                    <FormGroup className="NoMargin">

                        <CustomInput
                            type="checkbox"
                            name="AseConsent"
                            id="AseConsent"
                            onChange={this.aseChange}
                            label={

                                <span>
                                    <b>Øg dine chancer for at blive godkendt!</b> Få et billigt og uforpligtende tilbud på a-kasse fra Ase. Du takker ja til en gratis gennemgang telefonisk af Ase, hvor du vil modtage et personligt tilbud. Øvrige betingelser og oplysninger om Ase’s behandling af persondata kan læses ved at klikke <a href="https://www.ase.dk/cookie-privatliv-og-persondata/samtykke" target="_blank">her</a>.
                                </span>

                            }
                        />

                        { /*<CustomInput
                            type="checkbox"
                            name="AlmBrandConsent"
                            id="AlmBrandConsent"
                            onChange={this.AlmBrandChange}
                            label={

                                <span>
                                    Ja tak, jeg vil gerne bestille et telefonisk forsikringstjek af Alm Brand og høre mere om, hvordan jeg kan blive bedre dækket. Det er helt gratis og uforpligtende. Jeg vil også gerne modtage e-mail og sms med tilbud om forsikringer, nyheder, samt information om skadeforebyggende produkter og tiltag. Alm Brand videregiver ikke mine oplysninger til tredjemand og mit samtykke kan altid tilbagekaldes. <a href="https://www.almbrand.dk/4aca31/siteassets/pdf/brochurer/_gdpr.pdf">Se privatlivspolitikken her</a>.
                                </span>

                            }
                        />
                        */}

                        <Label for="accepted" className="">

                        </Label>
                    </FormGroup>

                    <br />
                </ApplicationContent>
                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                            <Button className="back" onClick={() => this.props.previous()}>
                                Tilbage
              </Button>
                            <Button className="next" onClick={() => this.submit()}>
                                Ansøg
              </Button>
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: any) => any) => ({
    setCprAndPaymentMethod: (cpr: string, paymentMethod: PaymentMethod, hasOldLoan: HasOldLoan, oldLoanAmount: string, accountNr: string, regNr: string) => {
        dispatch(setCprAndPaymentMethod(cpr, paymentMethod, hasOldLoan, oldLoanAmount, accountNr, regNr));
    },
    setAseConsent: (aseConsent: boolean) => {
        dispatch(setAseConsent(aseConsent));
    },
    setAlmBrandConsent: (almBrandConsent: boolean) => {
        dispatch(setAlmBrandConsent(almBrandConsent));
    },
    previous: () => dispatch(gotoStep(Step.Cars)),
    sendApplication: () => dispatch(sendApplication())

});


export default connect(mapStateToProps, mapDispatchToProps)(StepPayment);
